<div
  class="avatar"
  [ngStyle]="{
    'border-color': learner().colour,
    'width.px': 32,
    'height.px': 32,
  }"
>
  @if (learner().pictureUrl && learner().pictureUrl !== '') {
    @if (learner().pictureUrl | authImageUrl | async; as imageUrl) {
      @if (imageUrl) {
        <img
          [src]="imageUrl"
          [alt]="learner().firstname + ' Avatar'"
          class="avatar-image"
          [style.width.px]="size()"
          [style.height.px]="size()"
        />
      } @else {
        <ng-container
          [ngTemplateOutlet]="avatarPlaceholder"
          [ngTemplateOutletContext]="{ borderColour: learner().colour }"
        />
      }
    } @else {
      <ng-container
        [ngTemplateOutlet]="avatarPlaceholder"
        [ngTemplateOutletContext]="{ borderColour: learner().colour }"
      />
    }
  } @else {
    <!-- Show placeholder when no image -->
    <ng-container
      [ngTemplateOutlet]="avatarPlaceholder"
      [ngTemplateOutletContext]="{ borderColour: learner().colour }"
    />
  }
</div>

<ng-template #avatarPlaceholder let-borderColour="borderColour">
  <svg class="placeholder" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M35.8919 40.5857C35.332 40.5896 34.7764 40.4895 34.2531 40.291L27.1533 37.5586C26.3464 37.2557 25.704 36.6279 25.3822 35.8282C25.0564 35.0093 25.0891 34.091 25.472 33.297C26.2643 31.6023 28.2954 30.7949 29.9996 31.4961L34.5409 33.3653C35.0394 33.5702 35.2774 34.1409 35.072 34.6393C34.8671 35.1377 34.2964 35.3758 33.798 35.1704L29.2566 33.3008C28.5146 32.9957 27.5912 33.3726 27.2401 34.1237C27.0884 34.4279 27.0713 34.782 27.1924 35.0995C27.3145 35.3955 27.5551 35.6267 27.8554 35.7372L34.9577 38.4695C35.2572 38.5825 35.5748 38.6388 35.8945 38.6363C36.7611 38.6363 37.6768 38.2543 38.3445 37.6149C39.2258 36.7693 39.5408 35.6263 39.1253 34.7699L33.9325 24.0166C32.7354 21.5136 30.2445 19.8855 27.4713 19.7932L24.3982 21.9059C22.9527 22.8916 21.0513 22.8916 19.6059 21.9059L16.5327 19.7932C13.76 19.8851 11.2686 21.5136 10.0715 24.0166L4.87918 34.7678C4.46539 35.6237 4.78035 36.7667 5.65992 37.6123C6.32723 38.2517 7.24332 38.6337 8.11 38.6337C8.43012 38.6371 8.74809 38.5813 9.04801 38.4691L16.1529 35.7367C16.4528 35.6263 16.6926 35.3951 16.8138 35.0999C16.9354 34.7824 16.9182 34.4288 16.7669 34.1241C16.4154 33.3734 15.492 32.9966 14.7504 33.3017L10.209 35.1713C9.71059 35.3762 9.13996 35.1386 8.935 34.6402C8.73004 34.1417 8.96766 33.5711 9.4661 33.3661L14.0075 31.497C15.712 30.7957 17.7427 31.6031 18.5351 33.2978C18.9179 34.0919 18.9506 35.0097 18.6249 35.8291C18.303 36.6279 17.6611 37.2552 16.855 37.5582L9.75012 40.2906C9.22762 40.4899 8.67246 40.5905 8.11344 40.587C6.735 40.587 5.34926 40.0173 4.31242 39.026C2.81625 37.5947 2.34016 35.5438 3.12176 33.9239L8.31496 23.1727C9.90266 19.8847 13.1653 17.8385 16.8284 17.8385C17.026 17.8385 17.2185 17.8982 17.3814 18.0104L20.7132 20.2985C21.4913 20.8296 22.5157 20.8296 23.2939 20.2985L26.6244 18.0078C26.7872 17.8961 26.9797 17.8359 27.1774 17.8359C30.8405 17.8359 34.1022 19.8791 35.6908 23.1701L40.8793 33.9196C41.66 35.5386 41.183 37.5887 39.6895 39.0208C38.6552 40.0155 37.2699 40.5857 35.8919 40.5857Z"
      [attr.fill]="borderColour"
    />
    <path
      d="M12.6672 41.2532C12.1284 41.2532 11.6914 40.8162 11.6914 40.2773V38.1164C11.6914 37.5776 12.1284 37.1406 12.6672 37.1406C13.2061 37.1406 13.643 37.5776 13.643 38.1164V40.2773C13.643 40.8162 13.2061 41.2532 12.6672 41.2532Z"
      [attr.fill]="borderColour"
    />
    <path
      d="M31.3371 41.2545C30.7983 41.2545 30.3613 40.8175 30.3613 40.2786V38.1164C30.3613 37.5776 30.7983 37.1406 31.3371 37.1406C31.876 37.1406 32.313 37.5776 32.313 38.1164V40.2786C32.313 40.8175 31.876 41.2545 31.3371 41.2545Z"
      [attr.fill]="borderColour"
    />
    <path
      d="M14.3801 33.3727C13.8413 33.3727 13.4043 32.9357 13.4043 32.3969V26.3039C13.4043 25.7651 13.8413 25.3281 14.3801 25.3281C14.9189 25.3281 15.3559 25.7651 15.3559 26.3039V32.3943C15.3572 32.9332 14.9215 33.3714 14.3827 33.3727C14.3818 33.3727 14.381 33.3727 14.3801 33.3727Z"
      [attr.fill]="borderColour"
    />
    <path
      d="M29.6262 33.3727C29.0874 33.3727 28.6504 32.9357 28.6504 32.3969V26.3039C28.6504 25.7651 29.0874 25.3281 29.6262 25.3281C30.165 25.3281 30.602 25.7651 30.602 26.3039V32.3943C30.6033 32.9332 30.1676 33.3714 29.6288 33.3727C29.6279 33.3727 29.6271 33.3727 29.6262 33.3727Z"
      [attr.fill]="borderColour"
    />
    <path
      d="M22.0015 41.2535C21.8859 41.2535 21.7716 41.2324 21.6633 41.1925L14.0398 38.372C13.5345 38.1851 13.2763 37.6235 13.4632 37.1182C13.6501 36.6129 14.2117 36.3546 14.717 36.5415L22.0028 39.2374L29.2886 36.5415C29.7939 36.3542 30.3555 36.6124 30.5428 37.1177C30.7302 37.6231 30.4719 38.1847 29.9666 38.372L22.3392 41.1925C22.231 41.2324 22.1167 41.2535 22.0015 41.2535Z"
      [attr.fill]="borderColour"
    />
    <path
      d="M22.0078 30.109H22.0001C21.7324 30.1086 21.4767 29.9965 21.2954 29.7992C21.2357 29.7399 20.2332 28.7676 17.9374 27.9224C15.7653 27.1227 14.5287 27.2718 14.5162 27.2718H14.5278L14.2305 25.343C14.3998 25.3167 15.9595 25.1165 18.6111 26.0932C20.2706 26.7042 21.3637 27.3788 22.0022 27.8536C22.6416 27.3788 23.7347 26.7042 25.3942 26.0932C28.0458 25.1174 29.6055 25.3172 29.774 25.343L29.4775 27.2718H29.4887C29.4771 27.2718 28.2404 27.1227 26.0684 27.9224C23.6991 28.7946 22.7228 29.7859 22.7129 29.7958C22.5316 29.9939 22.2759 30.1069 22.0078 30.109Z"
      [attr.fill]="borderColour"
    />
    <path
      d="M22.0022 17.2137C18.007 17.2141 14.768 13.9755 14.7676 9.98031C14.7671 5.98508 18.0057 2.74652 22.0009 2.74609C25.9962 2.74566 29.2352 5.98422 29.2356 9.97945C29.2356 9.97988 29.2356 9.97988 29.2356 9.98031C29.2313 13.973 25.9953 17.2094 22.0022 17.2137ZM22.0022 4.69773C19.0851 4.69773 16.7201 7.06273 16.7201 9.97988C16.7201 12.897 19.0851 15.262 22.0022 15.262C24.9194 15.262 27.2844 12.8975 27.2844 9.97988C27.2814 7.06402 24.9181 4.70074 22.0022 4.69773Z"
      [attr.fill]="borderColour"
    />
  </svg>
</ng-template>
